import { useEffect, type ReactNode } from "react";
import { Navigate, useNavigate } from "react-router";
import { authToken, setSessionEndedHandler } from "../api/client";

/**
 * Redirects to /login when no token is stored.
 *
 * Checked on every render — a sign-out clears the token and the next
 * navigation lands on the login screen without a full reload. It also listens
 * for the server ending the session (a 401 on any call), so an expired or
 * revoked worker is sent to sign in instead of seeing every screen fail.
 */
export function AuthGuard({ children }: { children: ReactNode }) {
  const navigate = useNavigate();

  useEffect(() => {
    setSessionEndedHandler(() => void navigate("/login", { replace: true }));
    return () => setSessionEndedHandler(null);
  }, [navigate]);

  if (!authToken.get()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
